import { LARGE_DEVICE_WIDTH_MAX, SMALL_DEVICE_WIDTH_MAX } from "@consts";

export default {
	name: "Logo",
	data() {
		return {
			LARGE_DEVICE_WIDTH_MAX,
			SMALL_DEVICE_WIDTH_MAX,
			// Render default logo during SSR/hydration; flip post-mount.
		};
	},
	computed: {
		pictureSources() {
			if (this.$isBlueBranding) {
				const desktopWebpSrcset = [
					"/static/images/logo-desktop.webp 1x",
					"/static/images/logo-desktop@2x.webp 2x",
					"/static/images/logo-desktop@3x.webp 3x",
				].join(", ");
				const desktopPngSrcset = [
					"/static/images/logo-desktop.png 1x",
					"/static/images/logo-desktop@2x.png 2x",
					"/static/images/logo-desktop@3x.png 3x",
				].join(", ");
				const mobileWebpSrcset = [
					"/static/images/logo-mobile.webp 1x",
					"/static/images/logo-mobile@2x.webp 2x",
					"/static/images/logo-mobile@3x.webp 3x",
				].join(", ");
				const mobilePngSrcset = [
					"/static/images/logo-mobile.png 1x",
					"/static/images/logo-mobile@2x.png 2x",
					"/static/images/logo-mobile@3x.png 3x",
				].join(", ");

				return [
					{
						srcset: desktopWebpSrcset,
						media: `(min-width: ${LARGE_DEVICE_WIDTH_MAX + 1}px)`,
						type: "image/webp",
					},
					{
						srcset: desktopPngSrcset,
						media: `(min-width: ${LARGE_DEVICE_WIDTH_MAX + 1}px)`,
					},
					{
						srcset: desktopWebpSrcset,
						media: `(min-width: ${SMALL_DEVICE_WIDTH_MAX + 1}px)`,
						type: "image/webp",
					},
					{
						srcset: desktopPngSrcset,
						media: `(min-width: ${SMALL_DEVICE_WIDTH_MAX + 1}px)`,
					},
					{
						srcset: mobileWebpSrcset,
						type: "image/webp",
					},
					{
						srcset: mobilePngSrcset,
					},
				];
			}

			return [
				{
					srcset: "/static/images/ic_wfw_complete.webp",
					media: `(min-width: ${LARGE_DEVICE_WIDTH_MAX + 1}px)`,
					type: "image/webp",
				},
				{
					srcset: "/static/images/ic_wfw_complete.png",
					media: `(min-width: ${LARGE_DEVICE_WIDTH_MAX + 1}px)`,
				},
				{
					srcset: "/static/images/ic_wfw_complete.webp",
					media: `(min-width: ${SMALL_DEVICE_WIDTH_MAX + 1}px)`,
					type: "image/webp",
				},
				{
					srcset: "/static/images/ic_wfw_complete.png",
					media: `(min-width: ${SMALL_DEVICE_WIDTH_MAX + 1}px)`,
				},
				{
					srcset: "/static/images/ic_wfw_header.webp",
					type: "image/webp",
				},
			];
		},
		pictureSizeClass() {
			if (this.$isBlueBranding) {
				return "h-[30px] aspect-[48/30] md:h-[31px] md:aspect-[164/31] xl:h-[34px] xl:aspect-[180/34]";
			}

			return "h-[34px] aspect-[53/34] md:h-[31px] md:aspect-[158/31] xl:h-[37px] xl:aspect-[197/37]";
		},
		pictureImg() {
			if (this.$isBlueBranding) {
				return {
					src: "/static/images/logo-mobile.png",
					altTextDictionaryKey: "LogoTitleAttribute",
				};
			}

			return {
				src: "/static/images/ic_wfw_header.png",
				altTextDictionaryKey: "LogoTitleAttribute",
			};
		},
		logoInfo() {
			return {
				linkDictionaryKey: "/",
				attrDictionaryKey: "LogoTitleAttribute",
				altTextDictionaryKey: "LogoTitleAttribute",
				ariaLabelDictionaryKey: "LogoAriaLabel",
				gaEventLabel: "EN WF Logo",
				gaEventAction: "Click EN WF Logo navigation element",
				gaEventID: 2,
			};
		},
	},
	methods: {
		dispatchGaEvent() {
			this.$store.dispatch("tracking/trackEvent", {
				eventCategory: "Header",
				eventAction: this.logoInfo.gaEventAction,
				eventLabel: this.logoInfo.gaEventLabel,
				eventID: this.logoInfo.gaEventID,
			});
		},
	},
};
